// ── Pure utility functions for card-data extraction ───────────────────────────

import { PublishedCard } from "../types";

export const normalizePageType = (type?: string) =>
  (type || "")
    .replace(/[\s-]+/g, "_")
    .replace(/__+/g, "_")
    .toLowerCase();

export const isSingleCard = (card: PublishedCard) => {
  const meta = card as PublishedCard & { type?: string };
  return (
    normalizePageType(meta?.type) === "single_card" ||
    normalizePageType(card?.pages?.[0]?.type) === "single_card"
  );
};

export const isKIndieCard = (card: PublishedCard) =>
  normalizePageType(card?.pages?.[0]?.type) === "k_indie_card";

export const isDemoCard = (card: PublishedCard) => {
  const meta = card as PublishedCard & { type?: string };
  return (
    normalizePageType(meta?.type) === "demo_card" ||
    normalizePageType(card?.pages?.[0]?.type) === "demo_card"
  );
};

export const isListeningTogetherCard = (card: PublishedCard) => {
  const type = normalizePageType(card?.pages?.[0]?.type);
  return (
    type === "listening_together_card" ||
    type === "listen_together_card" ||
    type === "listeningtogethercard" ||
    type === "listentogethercard"
  );
};

export const isLinkCard = (card: PublishedCard) => {
  const type = normalizePageType(card.pages?.[0]?.type);
  return type === "link_card" || type === "linkcard" || card.template === "Link Card Template";
};

export const isSeasonCard = (card: PublishedCard) => {
  const template = String(card?.template ?? "").toLowerCase();
  if (template.includes("season card")) {
    return true;
  }

  const meta = card as PublishedCard & { card_type?: string; type?: string };
  const topType = normalizePageType(meta?.type);
  if (topType === "season_card") {
    return true;
  }

  const type = normalizePageType(card?.pages?.[0]?.type);
  if (type === "season_card") {
    return true;
  }

  const primaryContent = card?.pages?.[0]?.content ?? {};
  if (String(primaryContent?.card_kind ?? "").toLowerCase() === "season_card") {
    return true;
  }

  const recordType = String(meta?.card_type ?? "").toLowerCase();
  if (recordType.includes("season")) {
    return true;
  }

  return false;
};

export const getTaasCardMeta = (card: PublishedCard) => {
  const firstPage = card?.pages?.[0];
  if (!firstPage) return {};
  const content = firstPage.content || {};
  const taasContent = content.taasCard || content;
  return {
    suit: taasContent?.suit || "",
    category: taasContent?.category || "",
    sub_category: taasContent?.sub_category || taasContent?.subcategory || "",
  };
};
